/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
import type { Query } from './Query';
import { QueryFromJSON, QueryFromJSONTyped, QueryToJSON } from './Query';

/**
 *
 * @export
 * @interface Audience
 */
export interface Audience {
  /**
   *
   * @type {string}
   * @memberof Audience
   */
  audienceId?: string;
  /**
   *
   * @type {number}
   * @memberof Audience
   */
  companyId: number;
  /**
   *
   * @type {number}
   * @memberof Audience
   */
  dateCreated?: number;
  /**
   *
   * @type {string}
   * @memberof Audience
   */
  dateCreatedIso?: string;
  /**
   *
   * @type {number}
   * @memberof Audience
   */
  dateModified?: number;
  /**
   *
   * @type {string}
   * @memberof Audience
   */
  dateModifiedIso?: string;
  /**
   *
   * @type {string}
   * @memberof Audience
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof Audience
   */
  key: string;
  /**
   * user-give name of the audience
   * @type {string | null}
   * @memberof Audience
   */
  name?: string | null;
  /**
   * a json representation of a user-inputed query with nested conditions
   * @type {Query}
   * @memberof Audience
   */
  query?: Query;
  /**
   *
   * @type {string}
   * @memberof Audience
   */
  state?: AudienceStateEnum;
  /**
   *
   * @type {Array<any>}
   * @memberof Audience
   */
  tags?: Array<any>;
}

/**
 * @export
 */
export const AudienceStateEnum = {
  Pending: 'pending',
  Active: 'active',
  Deleted: 'deleted',
} as const;
export type AudienceStateEnum =
  (typeof AudienceStateEnum)[keyof typeof AudienceStateEnum];

/**
 * Check if a given object implements the Audience interface.
 */
export function instanceOfAudience(value: object): value is Audience {
  if (!('companyId' in value) || value['companyId'] === undefined) return false;
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('key' in value) || value['key'] === undefined) return false;
  return true;
}

export function AudienceFromJSON(json: any): Audience {
  return AudienceFromJSONTyped(json, false);
}

export function AudienceFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Audience {
  if (json == null) {
    return json;
  }
  return {
    audienceId: json['audience_id'] == null ? undefined : json['audience_id'],
    companyId: json['company_id'],
    dateCreated:
      json['date_created'] == null ? undefined : json['date_created'],
    dateCreatedIso:
      json['date_created_iso'] == null ? undefined : json['date_created_iso'],
    dateModified:
      json['date_modified'] == null ? undefined : json['date_modified'],
    dateModifiedIso:
      json['date_modified_iso'] == null ? undefined : json['date_modified_iso'],
    id: json['id'],
    key: json['key'],
    name: json['name'] == null ? undefined : json['name'],
    query: json['query'] == null ? undefined : QueryFromJSON(json['query']),
    state: json['state'] == null ? undefined : json['state'],
    tags: json['tags'] == null ? undefined : json['tags'],
  };
}

export function AudienceToJSON(value?: Audience | null): any {
  if (value == null) {
    return value;
  }
  return {
    audience_id: value['audienceId'],
    company_id: value['companyId'],
    date_created: value['dateCreated'],
    date_created_iso: value['dateCreatedIso'],
    date_modified: value['dateModified'],
    date_modified_iso: value['dateModifiedIso'],
    id: value['id'],
    key: value['key'],
    name: value['name'],
    query: QueryToJSON(value['query']),
    state: value['state'],
    tags: value['tags'],
  };
}
